
import { 
  Droplets, 
  Heart, 
  Leaf, 
  Sparkles, 
  Flower, 
  Shield 
} from "lucide-react";

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <Droplets className="h-8 w-8 text-aqua" />,
      title: "Mindful Hydration",
      description: "Transform your daily water intake into a conscious ritual that helps you stay present and hydrated throughout the day."
    },
    {
      icon: <Heart className="h-8 w-8 text-roseQuartz" />,
      title: "Self-Care Ritual",
      description: "Create a personal connection to your hydration practice by incorporating the ancient wisdom of crystal energy."
    },
    {
      icon: <Flower className="h-8 w-8 text-amethyst" />,
      title: "Intention Setting",
      description: "Use your crystal water bottle as a daily reminder of your wellness intentions and personal growth goals."
    },
    {
      icon: <Leaf className="h-8 w-8 text-primary" />,
      title: "Natural Materials",
      description: "Made with BPA-free materials and genuine crystals for a pure, natural hydration experience."
    },
    {
      icon: <Shield className="h-8 w-8 text-aqua" />,
      title: "Quality Craftsmanship",
      description: "Durable design with premium materials means your bottle will be a long-lasting companion on your wellness journey."
    },
    {
      icon: <Sparkles className="h-8 w-8 text-citrine" />,
      title: "Beautiful Design",
      description: "Aesthetic appeal that makes staying hydrated a pleasure and serves as a conversation starter about your wellness practices."
    }
  ];
  
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4 text-foreground">Benefits of <span className="text-primary font-bold">Crystal Hydration</span></h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Discover how incorporating SlimCrystal into your daily routine can elevate your hydration practice.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="crystal-card p-6 hover:shadow-xl transition">
              <div className="mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-muted-foreground">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
